/* eslint-disable @typescript-eslint/no-explicit-any */
import Qs from 'qs'
import service from '@/services/service'
import { APIBlacklist } from '@/models/api/blacklist.model'

const resource = {
    main: 'services',
    module: 'blacklists'
}

export class BlacklistsServices {
    public static getBlacklists () {
        return service.get(`${resource.main}/${resource.module}`)
    }

    public static getBlacklistsPaginate (params: object) {
        return service.get(`${resource.main}/${resource.module}/paginate`, {
            params,
            paramsSerializer: (params) => {
                return Qs.stringify(params, { arrayFormat: 'indices' })
            }
        })
    }

    public static getBlacklistsById (id: number) {
        return service.get(`${resource.main}/${resource.module}/${id}`)
    }

    public static createBlacklists (params: APIBlacklist) {
        return service.post(`${resource.main}/${resource.module}`, params)
    }

    public static editBlacklists (params: APIBlacklist) {
        return service.put(`${resource.main}/${resource.module}/${params.blacklistId}`, params)
    }

    public static deleteBlacklists (id: number) {
        return service.delete(`${resource.main}/${resource.module}/${id}`)
    }

    public static createBlacklistsFromFile (params: File) {
        const form = new FormData()
        form.append('uploadfile', params)

        return service.post(`${resource.main}/${resource.module}/upload/add`, form, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    }

    public static deleteBlacklistsFromFile (params: File) {
        const form = new FormData()
        form.append('uploadfile', params)

        return service.put(`${resource.main}/${resource.module}/upload/remove`, form, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    }
}
